function isEmptyVotesResponse(response){
  const keys = Object.keys(response);
  const { length, } = keys;
  if (length > 1) {
    return false;
  }
  if (length === 0 ||
      (length === 1 && keys.includes('error'))) {
    return true;
  }
  return false;
}
export function transformGetVotesResponse(response){
  if (isEmptyVotesResponse(response)) {
    return {};
  }
  return {
    votes: Object.keys(response)
      .reduce((acc, curr) => {
        acc[curr.replace(/answer_/i, '')] = +response[curr];
        return acc;
      }, {})
  };
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarDataTransformer.js